import { bool, string } from "prop-types";

import Popover from "../../Popover";
import PlaceResources from "./PlaceResources";
import AppsResources from "./AppsResources";
import { useCurrentUser } from "../../../reducers/layoutReducer/selectors";

const ResourcesDropdown = ({ ariaLabelledBy, open }) => {
  const currentUser = useCurrentUser();

  return (
    <Popover aria-labelledby={ariaLabelledBy} className="tw-w-[232px]" open={open}>
      {currentUser.account.isPlace && <PlaceResources />}
      <AppsResources />
    </Popover>
  );
};

export default ResourcesDropdown;

ResourcesDropdown.propTypes = {
  ariaLabelledBy: string.isRequired,
  open: bool,
};

ResourcesDropdown.defaultProps = {
  open: false,
};
